export default __webpack_public_path__ + "static/media/lv4.2960cdfd.png";